// tslint:disable
export var EnrollmentStatus;
(function (EnrollmentStatus) {
    // Approved Enrollment Status
    EnrollmentStatus[EnrollmentStatus["Approved"] = 0] = "Approved";
    // Rejected Enrollment Status
    EnrollmentStatus[EnrollmentStatus["Rejected"] = 1] = "Rejected";
    // Review Required Enrollment Status
    EnrollmentStatus[EnrollmentStatus["Review_Required"] = 2] = "Review_Required";
    // Case Processing After Review
    EnrollmentStatus[EnrollmentStatus["Review_Processing"] = 3] = "Review_Processing";
    // Case Processing After Intake
    EnrollmentStatus[EnrollmentStatus["Intake_Processing"] = 4] = "Intake_Processing";
    // Disenrolled
    EnrollmentStatus[EnrollmentStatus["Disenrolled"] = 5] = "Disenrolled";
    // Enrolled
    EnrollmentStatus[EnrollmentStatus["Enrolled"] = 6] = "Enrolled";
    // Canceled
    EnrollmentStatus[EnrollmentStatus["Canceled"] = 7] = "Canceled";
    // Open
    EnrollmentStatus[EnrollmentStatus["Open"] = 8] = "Open";
    // Unknown
    EnrollmentStatus[EnrollmentStatus["Unknown"] = -1] = "Unknown";
    // EXPired
    EnrollmentStatus[EnrollmentStatus["EXP"] = 9] = "EXP";
})(EnrollmentStatus || (EnrollmentStatus = {}));
EnrollmentStatus['APPROVED'] = 0;
EnrollmentStatus['REJECTED'] = 1;
EnrollmentStatus['REVIEW_REQUIRED'] = 2;
EnrollmentStatus['REVIEW_PROCESSING'] = 3;
EnrollmentStatus['INTAKE_PROCESSING'] = 4;
EnrollmentStatus['DISENROLLED'] = 5;
EnrollmentStatus['ENROLLED'] = 6;
EnrollmentStatus['CANCELED'] = 7;
EnrollmentStatus['OPEN'] = 8;
EnrollmentStatus['UNKNOWN'] = -1;
//# sourceMappingURL=EnrollmentStatus.js.map